// DO NOT EDIT MANUALLY
// This file was automatically generated by `scripts/MapboxStyles/process.ts`

import { MapboxStyleLayer } from '../types'

export const mapboxStyleGroupLayers_atlas_boundaries_names: MapboxStyleLayer[] = [
  {
    type: 'symbol',
    id: 'name_category_municipality',
    paint: {
      'text-color': '#bc6a2f',
      'text-halo-width': 1,
      'text-halo-color': '#ffffff',
    },
    layout: {
      'text-field': [
        'concat',
        ['to-string', ['get', 'name:prefix']],
        ' ',
        ['to-string', ['get', 'name']],
      ],
      'text-size': 12,
    },
    filter: ['has', 'category_municipality'],
  },
  {
    type: 'symbol',
    id: 'name_category_district',
    paint: {
      'text-color': '#bc6a2f',
      'text-halo-color': '#ffffff',
      'text-halo-width': 2,
    },
    layout: {
      'text-field': [
        'concat',
        ['to-string', ['get', 'name:prefix']],
        ' ',
        ['to-string', ['get', 'name']],
      ],
      'text-size': 14,
    },
    filter: ['has', 'category_district'],
  },
]
